import React, { useState } from "react";
import { TextWrapper, ReadMoreToggle } from "./styles";

// Walk backwards from `ideal` to find a word boundary, falling back to `ideal`
const getTruncationIndex = (text, min, ideal) => {
  for (let i = ideal; i >= min; i--) {
    if (text[i] === " ") return i;
  }
  return ideal;
};

/**
 * Truncates long text at a natural word boundary with an expand toggle.
 * Drop-in replacement for read-more-react.
 */
const ReadMore = ({
  text = "",
  min = 100,
  ideal = 200,
  max = 300,
  readMoreText = "Read more...",
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!text || text.length <= max) {
    return <TextWrapper>{text}</TextWrapper>;
  }

  const truncateAt = getTruncationIndex(text, min, ideal);
  const truncated = text.slice(0, truncateAt).trimEnd();

  return (
    <TextWrapper>
      {expanded ? text : truncated}
      {!expanded && (
        <>
          {"... "}
          <ReadMoreToggle
            type="button"
            aria-label="Read more"
            onClick={() => setExpanded(true)}
          >
            {readMoreText}
          </ReadMoreToggle>
        </>
      )}
    </TextWrapper>
  );
};

export default ReadMore;
